export default "__VITE_ASSET__Cjyz8Xrg__"